import React, { Component } from 'react'
import Select from 'react-select'
import { Options, QtyMinus, QtyPlus, Plus } from './icons'
import { navigate } from 'gatsby'
import Link from '../utils/link'

let categories = [
  { label: "For Sale", value: 'for-sale' },
  { label: "For Lease", value: 'for-lease' },
  { label: "Sold", value: 'sold' },
]

const rentRangeMin = [
  { label: "$0", value: 0 },
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
]

const rentRangeMax = [
  { label: "$0", value: 0 },
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1,000", value: 1000 },
  { label: "$1,500", value: 1500 },
  { label: "$2,000", value: 2000 },
  { label: "$2,500", value: 2500 },
  { label: "$3,000", value: 3000 },
  { label: "$4,000", value: 4000 },
  { label: "$5,000", value: 5000 },
  { label: "$10,000", value: 99999 },
]

const priceRangeMin = [
  { label: "$100,000", value: 100000 },
  { label: "$200,000", value: 200000 },
  { label: "$300,000", value: 300000 },
  { label: "$400,000", value: 400000 },
  { label: "$500,000", value: 500000 },
  { label: "$600,000", value: 600000 },
  { label: "$700,000", value: 700000 },
  { label: "$800,000", value: 800000 },
  { label: "$900,000", value: 900000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,500,000", value: 1500000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,500,000", value: 2500000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$3,500,000", value: 3500000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$4,500,000", value: 4500000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$5,500,000", value: 5500000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$6,500,000", value: 6500000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$7,500,000", value: 7500000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$8,500,000", value: 8500000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$9,500,000", value: 9500000 },
  { label: "$10,000,000", value: 100000000 },
  { label: "$12,000,000", value: 120000000 },
  { label: "$15,000,000", value: 150000000 },
  { label: "$20,000,000", value: 200000000 },
  { label: "$30,000,000", value: 999999999 },
]

const priceRangeMax = [
  { label: "$500,000", value: 500000 },
  { label: "$600,000", value: 600000 },
  { label: "$700,000", value: 700000 },
  { label: "$800,000", value: 800000 },
  { label: "$900,000", value: 900000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,500,000", value: 1500000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,500,000", value: 2500000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$3,500,000", value: 3500000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$4,500,000", value: 4500000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$5,500,000", value: 5500000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$6,500,000", value: 6500000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$7,500,000", value: 7500000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$8,500,000", value: 8500000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$9,500,000", value: 9500000 },
  { label: "$10,000,000", value: 100000000 },
  { label: "$12,000,000", value: 120000000 },
  { label: "$15,000,000", value: 150000000 },
  { label: "$20,000,000", value: 200000000 },
  { label: "$30,000,000", value: 999999999 },
]

let typeOptions = [
  { label: "House", value: 'House' },
  { label: "Townhouse", value: 'Townhouse' },
  { label: "Apartment", value: 'Apartment' },
  { label: "Unit", value: 'Unit' },
  { label: "Off Market", value: 'Off Market' },
]

class SearchForm extends Component {

  state = {
    mobileSearch: false,
    moreOptions: false,
    searchPlaceholder: `Search`,
    search: '',
    category: this.props.type,
    bedrooms: 0,
    bathrooms: 0,
    carparks: 0,
    price_min: null,
    price_max: null,
    location: null,
    type: null,
  }

  componentDidMount() {

    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions)

    if (window.location?.search !== '') {
      let state = this.state
      state.moreOptions = true
      let queryStr = window.location?.search,
        queryArr = queryStr.replace('?', '').replace(/\+/g, ' ').split('&'),
        queryParams = []

      for (let i = 0; i < queryArr.length; i++) {
        let qArr = queryArr[i].split('=')
        if (qArr[1] === '' || qArr[1] === "undefined") continue
        qArr[1] = decodeURIComponent(qArr[1])
        queryParams.push({
          name: qArr[0],
          value: qArr[1],
        })
        if (qArr[0] === '') continue
        if (qArr[0] === 'price_min' || qArr[0] === 'price_max') {
          try {
            qArr[1] = JSON.parse(qArr[1])
          } catch (e) {
            // Not json
            qArr[1] = null
          }
        }
        let option = {
          currentTarget: {
            name: qArr[0],
            value: qArr[1],
          }
        }
        if (qArr[0] === 'search') {
          state[qArr[0]] = decodeURI(qArr[1])
        } else {
          state[qArr[0]] = parseInt(qArr[1])
        }
        this.handleSelectChange(option, { action: 'mount' })
      }

      this.setState({ state })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth < 900) {
      this.setState({ searchPlaceholder: `Start your search` });
    } else {
      this.setState({ searchPlaceholder: `Search address, area or agent` });
    }
  }

  onSubmit = (e) => {
    e.preventDefault()
    // smooth scroll to .search.offset top - 80px
    let search = document && document.querySelector('.search')
    if (search) {
      window.scrollTo({
        top: search.offsetTop - 60,
        behavior: 'smooth'
      })
    }
  }

  clearForm = () => {
    let state = {
      search: '',
      category: this.props.type,
      bedrooms: 0,
      bathrooms: 0,
      carparks: 0,
      price_min: null,
      price_max: null,
      location: null,
      type: null,
    }
    this.setState(state, this.updateList)
  }

  handleSelectChange = (option, field) => {
    let state = {}
    switch (field && field.action) {
      case 'select-option':
        state[field.name] = option
        break
      case 'mount':
        let { name, value } = option.currentTarget
        let item = this[name]?.props?.options?.find(el => {
          if (name === 'price_range' || name === 'rent_range')
            return el.value.min === value?.value.min && el.value.max === value?.value.max
          return el.value === value
        })
        if (item) {
          state[name] = item
        }
        break
      default:
        state[option.currentTarget.name] = option.currentTarget.value
        break
    }
    this.setState(state, this.updateList)
  }

  handleBedrooms = (operator) => {
    let { bedrooms } = this.state
    if (operator === 'plus') {
      bedrooms = bedrooms + 1
      if (bedrooms > 10) bedrooms = 10
    } else {
      bedrooms = bedrooms - 1
      if (bedrooms < 0) bedrooms = 0
    }
    this.setState({ bedrooms }, this.updateList)
  }
  handleBaths = (operator) => {
    let { bathrooms } = this.state
    if (operator === 'plus') {
      bathrooms = bathrooms + 1
      if (bathrooms > 10) bathrooms = 10
    } else {
      bathrooms = bathrooms - 1
      if (bathrooms < 0) bathrooms = 0
    }
    this.setState({ bathrooms }, this.updateList)
  }
  handleCars = (operator) => {
    let { carparks } = this.state
    if (operator === 'plus') {
      carparks = carparks + 1
      if (carparks > 10) carparks = 10
    } else {
      carparks = carparks - 1
      if (carparks < 0) carparks = 0
    }
    this.setState({ carparks }, this.updateList)
  }

  updateList = () => {
    const { list, set, staff } = this.props
    const { search, bedrooms, bathrooms, carparks, price_min, price_max, location, type } = this.state

    let results = {}

    if (list) {
      results = list.filter((el, i) => {
        const { propertyData, propertyAddress, propertyListing, propertyStaff } = el
        if (bedrooms && parseInt(propertyData.bedrooms) < bedrooms) return false
        if (bathrooms && parseInt(propertyData.bathrooms) < bathrooms) return false
        if (carparks && (parseInt(propertyData.totalParking)) < carparks) return false
        if (price_min && parseInt(propertyListing.searchPrice) < price_min.value) return false
        if (price_max && parseInt(propertyListing.searchPrice) > price_max.value) return false
        if (location && propertyAddress.suburb !== location.value) return false
        if (type && propertyData.category !== type.value && type.value !== 'Off Market') return false
        if (type && !propertyListing.offMarketListing && type.value === 'Off Market') return false

        if (search) {
          if (search.indexOf('Office:') !== -1) {
            let office = search.replace('Office: ', '')
            // replace Earlwood with Marickville
            if (office === 'CobdenHayson Earlwood') office = 'CobdenHayson Marrickville'
            if (propertyListing.officeName !== office) return false
          } else {
            // Concat address
            let address = Object.keys(propertyAddress).map(key => propertyAddress[key]).join(' ').toLowerCase()
            // Concat agent names
            let agents = propertyStaff.map(ps => {
              const agent = staff.find(
                (t) => t.teamDetails.id === ps.staffMemberId && ps.webDisplay
              )
              if (!agent) return null;
              return `${agent.teamDetails.firstName} ${agent.teamDetails.lastName}`;
            }).filter(ps => ps).join(' ').toLowerCase()

            if ((`${address} ${agents}`).indexOf(search.toLowerCase()) === -1) return false
          }

        }
        return true
      })
    }
    set(results)
  }

  _selectChange = option => {
    if (option.value === this.props.type) return
    navigate(`/${option.value}/`)
  }

  render() {
    let { price_min, price_max, bedrooms, bathrooms, carparks, searchPlaceholder, moreOptions, type, location } = this.state
    let { suburbs, types } = this.props

    let typeLabel = 'For Sale'
    if (this.props.type === 'lease') {
      typeLabel = 'For Lease'
      categories = [
        { label: "For Lease", value: 'for-lease' },
        { label: "For Sale", value: 'for-sale' },
        { label: "Sold", value: 'sold' },
      ]
    }
    if (this.props.type === 'sold') {
      typeLabel = 'Sold'
      categories = [
        { label: "Sold", value: 'sold' },
        { label: "For Sale", value: 'for-sale' },
        { label: "For Lease", value: 'for-lease' },
      ]
    }
    if (this.props.type === 'commercial_for_sale') {
      typeLabel = 'For Sale'
      categories = [
        { label: "For Sale", value: 'commercial-for-sale' },
        { label: "For Lease", value: 'commercial-lease' },
        { label: "Sold", value: 'commercial-sold' },
      ]
    }
    if (this.props.type === 'commercial_lease') {
      typeLabel = 'For Lease'
      categories = [
        { label: "For Lease", value: 'commercial-lease' },
        { label: "For Sale", value: 'commercial-for-sale' },
        { label: "Sold", value: 'commercial-sold' },
      ]
    }
    if (this.props.type === 'commercial_sold') {
      typeLabel = 'For Sold'
      categories = [
        { label: "Sold", value: 'commercial-sold' },
        { label: "For Sale", value: 'commercial-for-sale' },
        { label: "For Lease", value: 'commercial-lease' },
      ]
    }
    let suburbOptions = suburbs.map((el, i) => {
      return {
        label: el,
        value: el,
      }
    })
    // loop over types and create options
    let typeOptions = types.map((el, i) => {
      return {
        label: el,
        value: el,
      }
    })

    return (
      <section className='search'>
        <div className="search__inner">
          <ul className='search__mobile-categories'>
            <li><Link to='/for-sale/' className={`btn${typeLabel === 'For Sale' ? ' active' : ''}`}>For Sale</Link></li>
            <li><Link to='/for-lease/' className={`btn${typeLabel === 'For Lease' ? ' active' : ''}`}>For Lease</Link></li>
            <li><Link to='/sold/' className={`btn${typeLabel === 'Sold' ? ' active' : ''}`}>Sold</Link></li>
            <li><Link to='/team/' className="btn">Agents</Link></li>
          </ul>
          <form className='search__form form' onSubmit={(e) => this.onSubmit(e)}>
            <div className="form__row">
              <div className='form__select form__select--category'>
                <Select
                  options={categories}
                  onChange={this._selectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="category-desktop"
                  name="category"
                  value={typeLabel}
                  placeholder={typeLabel}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.category = node}
                />
              </div>
              <input className={`form__input${moreOptions ? ' active' : ''}`} type="text" name="search" value={this.state.search} placeholder={searchPlaceholder} onChange={this.handleSelectChange} />
              <div className='form__select form__select--price-range'>
                <Select
                  options={(this.props.type === 'lease' || this.props.type === 'commercial_lease') ? rentRangeMin : priceRangeMin}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="price_min"
                  name="price_min"
                  value={price_min}
                  placeholder="Price Min"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.price_min = node}
                />
              </div>
              <div className='form__select form__select--price-range'>
                <Select
                  options={(this.props.type === 'lease' || this.props.type === 'commercial_lease') ? rentRangeMax : priceRangeMax}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="price_max"
                  name="price_max"
                  value={price_max}
                  placeholder="Price Max"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.price_max = node}
                />
              </div>
              <button
                type='button'
                className={`form__toggle${moreOptions ? ' active' : ''}`}
                onClick={() => this.setState({ moreOptions: !moreOptions })}
              >
                {moreOptions ? 'Less' : 'More'} Filters
                <Options color={'#000000'} />
              </button>
              <button className={`form__submit${moreOptions ? ' active' : ''}`} type='submit'>Search</button>
            </div>
            <button
              type='button'
              className={`form__mobile-toggle${moreOptions ? ' active' : ''}`}
              onClick={() => this.setState({ moreOptions: !moreOptions })}
            >
              <Plus color={'#000000'} />
              {moreOptions ? 'Close' : 'More'} Filters
            </button>
            <div className={`form__row form__row--dropdowns${moreOptions ? ' active' : ''}`}>
              <div className='form__select form__select--type'>
                <Select
                  options={typeOptions}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="type"
                  name="type"
                  value={type}
                  placeholder="Type"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.type = node}
                />
              </div>
              <div className='form__select form__select--location'>
                <Select
                  options={suburbOptions}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="location"
                  name="location"
                  value={location}
                  placeholder="Location"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.location = node}
                />
              </div>
              <div className='form__select form__select--price-range'>
                <Select
                  options={(this.props.type === 'lease' || this.props.type === 'commercial_lease') ? rentRangeMin : priceRangeMin}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="price_min"
                  name="price_min"
                  value={price_min}
                  placeholder="Price Min"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.price_min = node}
                />
              </div>
              <div className='form__select form__select--price-range'>
                <Select
                  options={(this.props.type === 'lease' || this.props.type === 'commercial_lease') ? rentRangeMax : priceRangeMax}
                  onChange={this.handleSelectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="price_max"
                  name="price_max"
                  value={price_max}
                  placeholder="Price Max"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => this.price_max = node}
                />
              </div>
              {this.props.type !== 'commercial_sold' && this.props.type !== 'commercial_for_sale' && (
                <>
                  <div className='form__number form__select--bed'>
                    <label>Beds</label>
                    <button type='button' className='form__number-minus' onClick={() => this.handleBedrooms('minus')}>
                      <QtyMinus />
                    </button>
                    <input className='form__number-input' type="number" name="bedrooms" value={bedrooms} min="0" max="10" readOnly />
                    <button type='button' className='form__number-plus' onClick={() => this.handleBedrooms('plus')}>
                      <QtyPlus />
                    </button>
                  </div>
                  <div className='form__number form__select--bath'>
                    <label>Baths</label>
                    <button type='button' className='form__number-minus' onClick={() => this.handleBaths('minus')}>
                      <QtyMinus />
                    </button>
                    <input className='form__number-input' type="number" name="bathrooms" value={bathrooms} min="0" max="10" readOnly />
                    <button type='button' className='form__number-plus' onClick={() => this.handleBaths('plus')}>
                      <QtyPlus />
                    </button>
                  </div>
                  <div className='form__number form__select--car'>
                    <label>Cars</label>
                    <button type='button' className='form__number-minus' onClick={() => this.handleCars('minus')}>
                      <QtyMinus />
                    </button>
                    <input className='form__number-input' type="number" name="carparks" value={carparks} min="0" max="10" readOnly />
                    <button type='button' className='form__number-plus' onClick={() => this.handleCars('plus')}>
                      <QtyPlus />
                    </button>
                  </div>

                </>
              )}
              <button
                type='button'
                className='form__clear'
                onClick={() => this.clearForm()}
              >
                Clear
              </button>
              <button
                type='button'
                className='form__close'
                onClick={() => this.setState({ moreOptions: !moreOptions })}
              >
                Search
              </button>
            </div>
          </form>
        </div>
      </section>
    )
  }
}

export default SearchForm